import React, { useEffect, useState, useContext, useRef } from "react";
import InfinityGridBrandsCards from "../../common/cardContainers/InfinityGridBrandsCards";
import styled from "styled-components";
import { APP_TITLE } from "../../../config/constant";
import ListComponent from "../../common/lists/ListComponent";
import * as Library from "../../../utils/Library";
import { AppQueryClient } from "../../../api/queryClient";
import DialogBoxComponent from "../../common/dialogs/DialogBoxComponent";
import FullScreenOverlay from "../../common/overlay/FullScreenOverlay";
import { formatDefaultDateTime } from "../../../utils/Formatter";
import { useNavigate, useOutletContext } from "react-router";
import { useSelector } from "react-redux";
import { defaultStatusColors } from "../../../utils/CardUtils";
import MainWindowHeader, { CustomSearch } from "../../common/mainApp/mainWindowHeaders/MainWindowHeader";
import { useQueryClient } from "react-query";
import AppContext from "../../../AppContext";
import { roleAccesse } from "../../../utils/roleManager";

/* #region  SCOPED CSS */
const StyledPage = styled.div`
    & {
        overflow-y: hidden;
        height: 100%;
        margin-right: -23px;
        margin-left: -24px;
        padding-left: 24px;
        padding-right: 24px;
    }
`;
/* #endregion */

export default function BrandsPage() {
    document.title = `${APP_TITLE} - Brands`;

    /* #region STATES */
    const { MainLayoutProps, layoutType } = useOutletContext();
    const navigations = useSelector(state => state.navigationAccesses);
    const navigate = useNavigate();
    const { userData } = useContext(AppContext);
    const userRole = userData?.role;
    const editAccess = roleAccesse(userRole, "retail brand account admin");
    const props = {
        layoutType: layoutType,
        setControlBarLeftBtns: MainLayoutProps?.setControlBarLeftBtns,
        setControlBarCenterBtns: MainLayoutProps?.setControlBarCenterBtns,
        setControlBarRightBtns: MainLayoutProps?.setControlBarRightBtns,
        setFilterHeaderProperties: MainLayoutProps?.setFilterHeaderProperties,
        setRefreshUserData: MainLayoutProps?.setRefreshUserData,
        navigations: navigations
    };
    const queryClient = useQueryClient();
    const gridRef = useRef(null);

    const [viewLayoutStyle, setViewLayoutStyle] = useState("Grid");
    const [isLoading, setIsLoading] = useState(false);
    const [removeID, setRemoveID] = useState(null);

    //---------- Header Filters
    const [searchText, setSearchText] = useState("");
    const [toogleSuspendData, setToogleSuspendData] = useState(null);

    const [listNumRows, setListNumRows] = useState(50);

    const filters = {
        searchText: searchText
    };

    const gridQueryKey = ["BrandsGrid", filters];
    const listQueryKey = ["BrandsList", filters];
    /* #endregion */

    /* #region EFFECTS */
    useEffect(() => {
        setViewLayoutStyle(props?.layoutType);
        setupHeaders(props, onClickRefreshAction, navigations, onSearch, editAccess);
    }, [props?.layoutType, editAccess]);

    useEffect(() => {
        Library.removeQueries(queryClient, gridQueryKey);
        Library.removeQueries(queryClient, listQueryKey);
    }, []);
    /* #endregion */

    /* #region LIST COMPONENT PROPS */
    const listColumns = [
        {
            name: "Brand",
            selector: row => row?.name ?? "--"
        },
        {
            name: "Created by",
            selector: row => row?.createdBy ?? "--"
        },
        {
            name: "Created on",
            selector: row => formatDefaultDateTime(row?.createdOn) ?? "--"
        },
        {
            name: "Company",
            selector: row => row?.companyName ?? "--"
        },
        {
            name: "Utilizing shopify",
            selector: row => (row?.utilizingShopify ? "YES" : "NO")
        },
        {
            name: "Stores",
            selector: row => row?.totalStores ?? "--"
        },
        {
            name: "FFcenters",
            selector: row => row?.totalffcenters ?? "--"
        },
        {
            name: "POS",
            selector: row => row?.POSsystem ?? "--"
        }
    ];
    /* #endregion */

    /* #region METHODS */
    const onSearch = searchText => {
        setSearchText(searchText);
    };

    const handleEditBrand = itemData => {
        navigate(`/brands/edit/${itemData?._id}`);
    };

    /*const handleDelete = async itemData => {
        const itemID = itemData?.id;

        if (!itemID) {
            Library.showErrorMessage("Invalid item ID!");
            return;
        }

        setRemoveID(itemID);
    };*/

    const makeDeleteRequest = itemID => {
        setIsLoading(true);

        /*setTimeout(() => {
            setIsLoading(false);
            setRemoveID(null);
            Library.showSuccessMessage("Brand deleted successfully!");
        }, 2000);*/

        Library.makePostRequest("deleteGroupLabelBrand", { labelBrandID: itemID }, false, setIsLoading)
            .then(res => {
                if (res.data.status !== 200) return;
                setIsLoading(false);
                setRemoveID(null);
                Library.showSuccessMessage("Brand deleted successfully!");
                props?.getUserDataFunction(localStorage.getItem("token"));
                onClickRefreshAction();
            })
            .catch(err => {
                setIsLoading(false);
                setRemoveID(null);
            });
    };

    /*const handleToogleSuspend = itemData => {
        const itemID = itemData?.id;

        if (!itemID) {
            Library.showErrorMessage("Invalid item ID!");
            return;
        }

        setToogleSuspendData(itemData);
    };*/

    const toogleSuspend = itemData => {
        setIsLoading(true);

        const groupCompanyID = localStorage.getItem("currentCompanyID");
        const itemID = itemData?.id;
        const status = itemData?.status === "Active" ? "Suspended" : "Active";

        Library.makePostRequest(
            "updateGroupLabelBrandStatus",
            {
                groupCompanyID,
                labelBrandID: itemID,
                status
            },
            false,
            setIsLoading
        )
            .then(res => {
                if (res.data.status !== 200) return;
                setIsLoading(false);
                setToogleSuspendData(null);
                Library.showSuccessMessage(
                    status === "Active" ? "Brand activated successfully!" : "Brand suspended successfully!"
                );

                props?.getUserDataFunction(localStorage.getItem("token"));
                onClickRefreshAction();
            })
            .catch(err => {
                setIsLoading(false);
                setToogleSuspendData(null);
            });
    };

    const onClickRefreshAction = () => {
        if (props?.layoutType === "List") AppQueryClient.invalidateQueries(listQueryKey);
        else {
            //else AppQueryClient.invalidateQueries(gridQueryKey);
            gridRef.current?.reset?.(gridQueryKey);
        }
    };

    /* #endregion */

    return (
        <StyledPage>
            <FullScreenOverlay show={toogleSuspendData !== null}>
                <DialogBoxComponent
                    title={toogleSuspendData?.status === "Active" ? "Suspend Brand" : "Activate Brand"}
                    message={
                        toogleSuspendData?.status === "Active"
                            ? `Are you sure you want to suspend ${toogleSuspendData?.name} brand?`
                            : `Are you sure you want to activate ${toogleSuspendData?.name} brand?`
                    }
                    //message={`${toogleSuspendData?.brandName} status will become SUSPENDED until you reactivate the account. ${toogleSuspendData?.brandName} will be logged out of their account. This may take up to 30 minutes to take effect. No email will be sent.`}
                    onClickYes={() => {
                        toogleSuspend(toogleSuspendData);
                    }}
                    loading={isLoading}
                    loadingHeading={
                        toogleSuspendData?.status === "Active" ? "Suspending Brand..." : "Activating Brand..."
                    }
                    onClickNo={() => {
                        setToogleSuspendData(null);
                    }}
                />
            </FullScreenOverlay>

            <FullScreenOverlay show={removeID !== null}>
                <DialogBoxComponent
                    headingColor="var(--text-icons-red-500)"
                    title="Removing Brand"
                    message="Are you sure you want to remove this brand?"
                    onClickYes={() => {
                        makeDeleteRequest(removeID);
                    }}
                    loading={isLoading}
                    loadingHeading="Removing Brand..."
                    onClickNo={() => {
                        setRemoveID(null);
                    }}
                />
            </FullScreenOverlay>

            {viewLayoutStyle === "Grid" && (
                <InfinityGridBrandsCards
                    ref={gridRef}
                    minColumnWidth="370px"
                    limit="8"
                    //onDeleteAction={handleDelete}
                    //onSuspendAction={handleToogleSuspend}
                    queryKey={gridQueryKey}
                    statusFromPath="status"
                    onEditAction={handleEditBrand}
                    onClickRefreshAction={onClickRefreshAction}
                    filters={filters}
                    editAccess={editAccess}
                />
            )}
            {viewLayoutStyle === "List" && (
                <ListComponent
                    title="RETAIL BRANDS"
                    columns={listColumns}
                    api={{
                        endpoint: "getRetailBrandsData",
                        formData: {
                            companyID: localStorage.getItem("currentCompanyID"),
                            limit: listNumRows,
                            ...filters
                        }
                        //onSuccess: mapListData
                    }}
                    pageLimit={listNumRows}
                    currentPage={1}
                    queryKey={listQueryKey}
                    actions={{
                        includeActions: true,
                        onClickEdit: handleEditBrand,
                        //onClickRemove: handleDelete,
                        //onClickSuspend: handleToogleSuspend,
                        editIsVisible: true,

                        extraActions: [
                            {
                                title: "Details"
                            },
                            {
                                title: "FFCenters"
                            }
                        ]
                    }}
                    includeStatus={{
                        stickyStatus: true,
                        statusFromPath: "status",
                        statusColors: defaultStatusColors
                    }}
                    onChangeRowsPerPage={rowsPerPage => setListNumRows(rowsPerPage)}
                />
            )}
        </StyledPage>
    );
}

function setupHeaders(props, onRefreshAction, navigations, onSearch, editAccess) {
    const createMode = navigations?.navigationAccesses?.retailBrands?.createModeOnly;

    props.setControlBarLeftBtns([
        { customSearch: <CustomSearch enabled={true} onTextChange={onSearch} placeholder="Search" /> }
    ]);
    props.setControlBarCenterBtns([{ to: "/brands", active: true, disabled: false, title: "Brands" }]);
    props.setControlBarRightBtns([
        { to: "#", active: true, disabled: createMode, title: "View", icon: "eye" },
        {
            //to: editAccess ? "/brands/create" : "#",
            //disabled: editAccess ? createMode : true,
            to: "#",
            disabled: true,
            active: false,
            title: "Add",
            icon: "plus"
        },
        { to: "#", active: false, disabled: true, title: "Details", icon: "microscope" }
    ]);

    props.setFilterHeaderProperties({
        customContentHeader: (
            <MainWindowHeader
                key={window.location.pathname}
                visible={true}
                onRefreshClick={onRefreshAction}
                layoutTypeOptions={{
                    gridEnabled: true,
                    listEnabled: true
                }}
                firstOrganize={{
                    visible: true,
                    disabled: true
                }}
                secondOrganize={{
                    visible: true,
                    disabled: true
                }}
                search={{
                    visible: false
                }}
            />
        )
    });
}
